const STORAGE_KEY = "estore-cart-v1";
export const ESTORE_CART_EVENT = "estore-cart-updated";

function notify() {
  window.dispatchEvent(new Event(ESTORE_CART_EVENT));
}

export function readEstoreCart() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeEstoreCart(lines) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(lines));
  notify();
}

/** @typedef {{ productId: number; title: string; image: string; unitPrice: number; qty: number }} EstoreCartLine */

/** @param {Omit<EstoreCartLine, 'qty'> & { qty?: number }} line */
export function addToEstoreCart(line) {
  const items = readEstoreCart();
  const qty = line.qty ?? 1;
  const idx = items.findIndex((i) => i.productId === line.productId);
  if (idx >= 0) {
    items[idx] = { ...items[idx], qty: items[idx].qty + qty };
  } else {
    items.push({
      productId: line.productId,
      title: line.title,
      image: line.image,
      unitPrice: line.unitPrice,
      qty,
    });
  }
  writeEstoreCart(items);
}

export function updateEstoreCartQty(productId, qty) {
  const items = readEstoreCart();
  const next = items
    .map((i) => (i.productId === productId ? { ...i, qty } : i))
    .filter((i) => i.qty > 0);
  writeEstoreCart(next);
}

export function removeEstoreCartLine(productId) {
  writeEstoreCart(readEstoreCart().filter((i) => i.productId !== productId));
}

export function clearEstoreCart() {
  writeEstoreCart([]);
}

export function estoreCartCount() {
  return readEstoreCart().reduce((s, i) => s + i.qty, 0);
}

export function estoreCartSubtotal() {
  return readEstoreCart().reduce((s, i) => s + i.unitPrice * i.qty, 0);
}
